// extracted by mini-css-extract-plugin
module.exports = {"vanlife-K":"K_vanlife-K__tXvmq"};